/**
 * Content Slider Module
 * Initializes Swiper for content_slider blocks embedded in content_media_columns
 */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.content-slider[data-swiper-config]').forEach(function (el) {
    if (el.swiper) return;

    let config;
    try {
      config = JSON.parse(el.getAttribute('data-swiper-config'));
    } catch (e) {
      console.error('Content Slider: invalid swiper config', e);
      return;
    }

    const id = el.id;
    const modules = [];

    if (config.navigation) {
      modules.push(window.SwiperModules.Navigation);
    }
    if (config.pagination) {
      modules.push(window.SwiperModules.Pagination);
    }

    new window.Swiper(el, {
      modules: modules,
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      speed: 600,
      allowTouchMove: true,

      navigation: config.navigation ? {
        nextEl: '#' + id + ' .content-slider-next',
        prevEl: '#' + id + ' .content-slider-prev',
      } : false,

      pagination: config.pagination ? {
        el: el.querySelector('.content-slider-pagination'),
        clickable: true,
      } : false,
    });
  });
});
